
import PoliciesSidebar from "../navbar/PoliciesSidebar";
import { Outlet } from "react-router-dom";


const PoliciesLayout = ({ children }) => {
    return (
        <div className="policies-layout">
            <PoliciesSidebar />
            <div className="policies-content"><Outlet/></div>
        </div>
    );
};

export default PoliciesLayout;
